// @ts-check

export const SAMPLE_TASK_EVENT = "sample-task:selected"

/**
 * What Send does with the message in the input box. In Reviewer mode an
 * attached document goes through the review, as with Generate Review, so that
 * it opens as an editable document. As a plain attachment the model could only
 * read it.
 * @param {{ files?: any[], images?: any[] }} message
 * @param {boolean} isReviewer
 * @returns {"wait" | "review" | "send"}
 */
export function sendAction({ files = [], images = [] }, isReviewer) {
  if (!isReviewer || files.length === 0) return "send"
  if ([...files, ...images].some(attachment => attachment.uploadPromise != null)) return "wait"
  return "review"
}

/**
 * What a sample task card does. With nothing attached it only fills the input
 * box. With an attachment it sends at once, so the attachment goes with it.
 * @param {{ files?: any[], images?: any[] }} message
 * @param {boolean} isReviewer
 * @returns {"fill" | "wait" | "review" | "send"}
 */
export function sampleTaskAction(message, isReviewer) {
  const attachments = [...(message.files ?? []), ...(message.images ?? [])]
  if (attachments.length === 0) return "fill"
  if (attachments.some(attachment => attachment.uploadPromise != null)) return "wait"
  return sendAction(message, isReviewer)
}
